import api from './index'
import type { ApiResponse } from '@/types'

export interface FieldAssignmentPayload {
  fieldKey: string
  assigneeUserId?: string | null
}

export interface FieldAssignmentSummary {
  fieldKey: string
  label: string
  description: string | null
  sectionTitle: string | null
  frequency: string
  assigneeUserId: string | null
  assignee: {
    id: string
    name: string
    email: string
  } | null
}

export interface ProjectFieldAssignmentResponse {
  projectId: string
  template: {
    id: string
    name: string
    formType: string
  }
  version: {
    id: string
    versionNumber: number
  }
  fields: FieldAssignmentSummary[]
}

export const fetchProjectFieldAssignments = async (
  projectId: string,
  templateId: string,
): Promise<ApiResponse<ProjectFieldAssignmentResponse>> => {
  const response = await api.get(`/projects/id/${projectId}/forms/templates/${templateId}/field-assignments`)
  return response.data
}

export const updateProjectFieldAssignments = async (
  projectId: string,
  templateId: string,
  assignments: FieldAssignmentPayload[],
): Promise<ApiResponse<ProjectFieldAssignmentResponse>> => {
  const response = await api.put(
    `/projects/id/${projectId}/forms/templates/${templateId}/field-assignments`,
    { assignments },
  )
  return response.data
}
